import { Cancel, CheckCircle, Email, Event, Home, HourglassTop, LocationOn, Person, Phone, Smartphone } from "@mui/icons-material";
import { LoadingButton, Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator } from "@mui/lab";
import { Avatar, Box, Chip, Container, Divider, Grid, IconButton, ListItem, ListItemAvatar, ListItemText, Paper, Switch, Tooltip, Typography } from "@mui/material";
import { useGetUserByIdQuery } from "api/adminSlice";
import moment from "moment";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { generateCloudinaryLink } from "utils";

export default function AdminUserDetails() {
    const { t } = useTranslation()
    const { id } = useParams()

    const { data: user, userIsLoading } = useGetUserByIdQuery(id)

    //==============Update status==============
    const [checked, setChecked] = useState(false)

    const handleChange = (value) => {
        setChecked(value)
    }
    useEffect(() => {
        if (!!user) {
            if (user?.currentStatus === "ACTIVE") {
                setChecked(true)
            } else {
                setChecked(false)
            }
        }
    }, [user])

    const onUpdateStatusHandlers = () => {
        if (checked) {
            // onUpdateStatus("ACTIVE")
        } else {
            // onUpdateStatus("BLOCKED")
        }
    }

    const disabledConfirm = useMemo(() => {
        let currentStatus = checked ? ["ACTIVE"] : ["ACCOUNT_CREATED", "BLOCKED"]
        return currentStatus.includes(user?.currentStatus)
    }, [checked, user])

    return (
        <Container>
            <Grid container justifyContent="center">
                <Grid item xl={8} lg={8} md={9} sm={12} xs={12}>
                    <Paper sx={{ mt: 30, p: 15 }}>
                        <Box display="flex" justifyContent="center">
                            <Avatar
                                alt={user?.firstName}
                                src={generateCloudinaryLink(user?.image)}
                                sx={{ width: 125, height: 125 }}
                            />
                        </Box>
                        <Grid container justifyContent="space-between" spacing={20} sx={{ mt: 20 }}>
                            <Grid item xl={5} lg={5} md={6} sm={6} xs={12}>
                                <Tooltip placement="top" title={t("Full Name")}>
                                    <Box display="flex" alignItems="center">
                                        <Person color="primary" sx={{ mr: 20, mb: 5 }} />
                                        <Chip label={`${user?.firstName ?? '-'} ${user?.lastName ?? '-'}`} variant="outlined" color="primary" />
                                    </Box>
                                </Tooltip>
                            </Grid>
                            <Grid item xl={5} lg={5} md={6} sm={6} xs={12}>
                                <Tooltip placement="top" title={t("Phone")}>
                                    <Box display="flex" alignItems="center">
                                        <Phone color="primary" sx={{ mr: 20, mb: 5 }} />
                                        <bdi>
                                            <Chip label={user?.phone ?? '-'} variant="outlined" color="primary" />
                                        </bdi>
                                    </Box>
                                </Tooltip>
                            </Grid>
                            <Grid item xl={5} lg={5} md={6} sm={6} xs={12}>
                                <Tooltip placement="top" title={t("Email")}>
                                    <Box display="flex" alignItems="center">
                                        <Email color="primary" sx={{ mr: 20, mb: 5 }} />
                                        <Chip label={user?.email ?? '-'} variant="outlined" color="primary" />
                                    </Box>
                                </Tooltip>
                            </Grid>
                            <Grid item xl={5} lg={5} md={6} sm={6} xs={12}>
                                <Tooltip placement="top" title={t("Created At")}>
                                    <Box display="flex" alignItems="center">
                                        <Event color="primary" sx={{ mr: 20, mb: 5 }} />
                                        <Chip label={moment(user?.createdAt).format("DD/MM/YY - h:mm A")} variant="outlined" color="primary" />
                                    </Box>
                                </Tooltip>
                            </Grid>
                            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                                <Grid container justifyContent="space-between" alignItems="center">
                                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                                        <Box display="flex" alignItems="center">
                                            <Home color="primary" sx={{ mr: 20, mb: 5 }} />
                                            <Typography variant="h6" color="primary">{t("Addresses")}</Typography>
                                        </Box>
                                    </Grid>
                                    {
                                        user?.address.map(addr => (
                                            <Grid key={addr?.id} item xl={5} lg={5} md={6} sm={6} xs={12}>
                                                <ListItem
                                                    secondaryAction={
                                                        <Tooltip placement="top" title={t("Open on google map")}>
                                                            <IconButton
                                                                onClick={() => {
                                                                    window.open(`https://www.google.com/maps/place/${addr?.coords?.latitude},${addr?.coords?.longitude}`, "_blank")
                                                                }}
                                                            >
                                                                <LocationOn sx={{ color: "red" }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                    }
                                                >
                                                    <ListItemAvatar>
                                                        <Avatar sx={{ bgcolor: "primary.main" }}>
                                                            <Home />
                                                        </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                        primary={addr?.name}
                                                        secondary={addr?.description}
                                                    />
                                                </ListItem>
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* <Divider sx={{ my: 20 }} />
                        <Tooltip placement="top" title={t("Status")}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" mt={20}>
                                <Box display="flex" alignItems="center">
                                    {user?.currentStatus === "ACTIVE" && <CheckCircle color="success" sx={{ mr: 20, mb: 5 }} />}
                                    {user?.currentStatus === "BLOCKED" && <Cancel color="error" sx={{ mr: 20, mb: 5 }} />}
                                    {user?.currentStatus === "ACCOUNT_CREATED" && <HourglassTop color="warning" sx={{ mr: 20, mb: 5 }} />}
                                    <Typography
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        {t(`UserStatus.${user?.currentStatus}`)}
                                    </Typography>
                                    <Switch
                                        checked={checked}
                                        onChange={({ target: { checked } }) => handleChange(checked)}
                                    />
                                </Box>
                                <LoadingButton
                                    sx={{ textTransform: "none" }}
                                    disabled={disabledConfirm}
                                    variant="contained"
                                    size="small"
                                >
                                    {t("Confirm")}
                                </LoadingButton>
                            </Box>
                        </Tooltip> */}
                        <Divider sx={{ my: 20 }} />
                        <Box>
                            <Timeline position="alternate">
                                {
                                    user?.statusTrack?.map((item, index) => (
                                        <TimelineItem key={item?._id}>
                                            <TimelineOppositeContent color="text.secondary">
                                                {moment(item?.dateTime).format("DD/MM/YY - h:mm A")}
                                            </TimelineOppositeContent>
                                            <TimelineSeparator>
                                                <TimelineDot sx={{ backgroundColor: "white", boxShadow: "none", my: 0 }}>
                                                    {item?.status === "ACTIVE" && <CheckCircle color="success" />}
                                                    {item?.status === "BLOCKED" && <Cancel color="error" />}
                                                    {item?.status === "ACCOUNT_CREATED" && <HourglassTop color="warning" />}
                                                </TimelineDot>
                                                {index !== user?.statusTrack?.length - 1 && <TimelineConnector />}
                                            </TimelineSeparator>
                                            <TimelineContent sx={{ fontWeight: "bold" }}>{t(`UserStatus.${item?.status}`)}</TimelineContent>
                                        </TimelineItem>
                                    ))
                                }
                            </Timeline>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    )
}
